import React, { useEffect, useState } from "react";
import { Placement } from "react-bootstrap/esm/Overlay";
import { getToolTip } from "../../services/tooltips";
import InfoBubble from "./info-bubble";


export interface ApiTooltipProps {
    index: string;
    placement?: Placement
}

// could also maybe be an HOC?
function ApiTooltip({ index, placement }: ApiTooltipProps) {
    const tip = getToolTip(index)
    return tip ? <InfoBubble index={tip.key} tip={tip.value} placement={ placement} /> : <></>
}

export default ApiTooltip;